import {
	BY_POPULARITY,
	BY_PRICE_AND_POPULARITY,
	BY_SCORE_AND_POPULARITY,
} from "./Sorters";
import { translate } from "@escapio/shared/l10n/translate";
import { Selector } from "./Selector";
import { html, nothing } from "lit-html";
import "./Info";

customElements.define(
	"esc-hotel-list-sorting-selector-mobile",
	class extends Selector {
		constructor() {
			super([
				{
					value: BY_PRICE_AND_POPULARITY,
					label: translate("hotel_list_sort_by_price_short"),
				},
				{
					value: BY_SCORE_AND_POPULARITY,
					label: translate("hotel_list_sort_by_score_short"),
				},
				{
					value: BY_POPULARITY,
					label: translate("hotel_list_sort_by_popularity"),
				},
			]);
		}

		get template() {
			return html`${super.mobileTemplate}
			${this.selectedValue === BY_POPULARITY
				? html`<esc-hotel-list-sorting-info
						class="sorting-info-dropdown--list-header"
					></esc-hotel-list-sorting-info>`
				: nothing}`;
		}
	},
);
